var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex align-items-center" },
      [
        _c(
          "div",
          { staticClass: "w-100" },
          [
            _c("label", [_vm._v(_vm._s(_vm.label))]),
            _c(
              "v-select",
              {
                class: {
                  "v-select-danger": _vm.danger,
                  "select-size-sm": _vm.small
                },
                attrs: {
                  placeholder: "Busque por nombre",
                  options: _vm.listOptions,
                  name: _vm.name,
                  value: _vm.optionSelected,
                  disabled: _vm.isDisabled,
                  clearable: _vm.isClearable
                },
                on: { input: _vm.onInput },
                scopedSlots: _vm._u([
                  {
                    key: "spinner",
                    fn: function() {
                      return [
                        _vm.sanitaryCompaniesState.loading
                          ? _c("b-spinner", {
                              style: {
                                opacity: _vm.sanitaryCompaniesState.loading
                                  ? 1
                                  : 0
                              },
                              attrs: { small: "", variant: "primary" }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c("template", { slot: "no-options" }, [
                  _vm._v(
                    " no hay tipos de documentos para el criterio de búsqueda "
                  )
                ])
              ],
              2
            )
          ],
          1
        ),
        !_vm.isClearable
          ? _c("vs-icon", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Eliminar selección",
                  expression: "'Eliminar selección'"
                }
              ],
              staticClass: "ml-2 mt-5 pt-1 cursor-pointer",
              attrs: {
                icon: "remove_circle_outline",
                size: "small",
                color: "danger"
              },
              on: { click: _vm.clearSanitary }
            })
          : _vm._e()
      ],
      1
    ),
    _vm.danger
      ? _c("div", [
          _c("small", [
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(" " + _vm._s(_vm.dangerText) + " ")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }